export default "__VITE_ASSET__BGjz$Qox__"